import Icon from '../components/Icon.vue'

Icon.register({
  'address-card': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H528C554.5 480 576 458.5 576 432V80C576 53.5 554.5 32 528 32zM176 128C211.3 128 240 156.7 240 192S211.3 256 176 256 112 227.3 112 192 140.7 128 176 128zM288 364.8C288 375.4 278 384 265.6 384H86.4C74 384 64 375.4 64 364.8V345.6C64 313.8 94.1 288 131.2 288H136.2C148.5 293.1 161.9 296 176 296S203.6 293.1 215.8 288H220.8C257.9 288 288 313.8 288 345.6V364.8zM512 312C512 316.4 508.4 320 504 320H360C355.6 320 352 316.4 352 312V296C352 291.6 355.6 288 360 288H504C508.4 288 512 291.6 512 296V312zM512 248C512 252.4 508.4 256 504 256H360C355.6 256 352 252.4 352 248V232C352 227.6 355.6 224 360 224H504C508.4 224 512 227.6 512 232V248zM512 184C512 188.4 508.4 192 504 192H360C355.6 192 352 188.4 352 184V168C352 163.6 355.6 160 360 160H504C508.4 160 512 163.6 512 168V184z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/address-card.js
// module id = 3v3+
// module chunks = 144